export function createCost(data) {
    let { createCostRequest, createCostError, createCostResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'create_cost',
        this.createBundle('create_cost', { cost: data }, this.POST, createCostRequest, createCostResult, createCostError)
    )
}
